import React from 'react'

import UserLoader from './_load/UserLoader'
import { useUser } from './_load/UserLoader'
import UserPresenter from './UserPresenter'

const UserPresenterFromId = ({ ...props }) => {
  const user = useUser()

  return <UserPresenter user={user} {...props} />
}

const Wrapper = ({ id, ...props }) => {
  return (
    <UserLoader id={id}>
      <UserPresenterFromId {...props} />
    </UserLoader>
  )
}

export default Wrapper
